import React from 'react';
import styled from "styled-components"

import {
    Link,
    Trans,
    useTranslation,
    useI18next,
    I18nextContext
  } from "gatsby-plugin-react-i18next"

import { createStyles, Theme, makeStyles } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';

const useStyles = makeStyles((theme) =>
  createStyles({
    button: {
      margin: theme.spacing(1),
      width: 80,
    },
    wider: {
        width: 170,
    },
    extendedIcon: {
      marginRight: theme.spacing(1),
    },
  }),
);

const Question = styled.p`
    && {
        text-align: center;
        font-weight: 400;
        font-style: italic;
    }
`

const Answer = styled.p`
    && {
        text-align: center;
        font-weight: 400;
        font-style: italic;
    }
`

const Explanation = styled.p`
    && {
        text-align: center;
        font-weight: 700;
    }
`

const QuestionCard = ({questionNumber, question, answers, userAnswer, correctAnswer, callBack, explanation, wider}) => {

    const {t} = useI18next();

    const classes = useStyles();
    let background
    let colour

    return (
        <div>
            <Box justifyContent="center">
                <Question>{question}</Question>
            </Box>
            <Box>
                {
                    answers.map((answer)=>{
                        if (userAnswer && userAnswer.userAnswer === answer) {
                            background = (userAnswer.userAnswer === userAnswer.correctAnswer) ? "green" : "red"
                            colour = "white"
                        } else {
                            background = null
                            colour = null
                        }
                        return (
                        <Button variant="contained" size="medium" className={`${classes.button} ${wider} ? ${classes.wider} : ""}`} style={{backgroundColor: background, color: colour}} color="primary" disabled={userAnswer ? true : false} key={answer} value={answer} onClick={callBack}>
                            <span dangerouslySetInnerHTML={{ __html: answer }} />
                        </Button>
                        )
                    })
                }
            </Box>
            
            <Box>
                { userAnswer && (
                        <Answer>{t("TEST-YOURSELF.THE-CORRECT-ANSWER")}: {userAnswer.correctAnswer}</Answer> 
                    )
                }
            </Box>
             <Box>
                { userAnswer && (
                    <Explanation>{explanation}</Explanation>
                    )
                }
            </Box>
        </div>
    )
    
}

export default QuestionCard